import { Reservation } from './../assignato/reservation';

export class StatusChangeResponse {
    public code?: number;
    public error_message?: string;
    public response?: Reservation;
}